<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="pdl-20px pdr-20px">
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('gestionAffectation.popUpInstructionPose.title') }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content pdl-0 pdr-0">
        <div class="columns is-multiline">
          <b-field :label="$t('gestionAffectation.popUpInstructionPose.instructionPose')"
                   class="column is-12 mgb-0">
            <b-input v-model="instructionPose"></b-input>
          </b-field>
        </div>
        <footer>
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close()">
                {{ $t('addEditContratNature.actions.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="$emit('instructionPose', instructionPose)">
                {{ $t('general.button.sauvegarder') }}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'p_actionAffecter',
  props: {
    instructionPoseDefaut: {
      required: false,
      type: String,
      default: null,
    },
  },
  data() {
    return {
      instructionPose: null,
    };
  },
  mounted() {
    if (this.instructionPoseDefaut) {
      this.instructionPose = cloneDeep(this.instructionPoseDefaut);
    }
  },
};
</script>

<style scoped>

</style>
